import { render, staticRenderFns } from "./energyReport.vue?vue&type=template&id=96106836&scoped=true&"
import script from "./energyReport.vue?vue&type=script&lang=js&"
export * from "./energyReport.vue?vue&type=script&lang=js&"
import style0 from "./energyReport.vue?vue&type=style&index=0&id=96106836&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96106836",
  null
  
)

export default component.exports